<template>
    <div class="vitae">
        <section>
            <div class="container">
                <div v-for="entry in vita" :key="entry.company" class="vitae__row grid-x">
                    <div class="timespan columns medium-2 small-4">
                        <span class="timespan__from" :class="{isCentered: !entry.to}"> {{ entry.from }}</span>
                        <span v-if="entry.to" class="timespan__slash"></span>
                        <span v-if="entry.to && entry.to != 'ongoing'" class="timespan__to">   {{ entry.to }}</span>
                        <span v-if="entry.to && entry.to == 'ongoing'" class="timespan__to ongoing">   {{ entry.to }}</span>
                    </div>
                    <div class="columns medium-5 small-8 position">
                        <span class="position__head">
                            {{ entry.title }}
                        </span>
                        <a v-if="entry.companylink.url" :href="entry.companylink.url" target="_blank" class="position__company">
                            {{ entry.company }}
                        </a>
                        <span v-else class="position__company">
                            {{ entry.company }}
                        </span>
                    </div>
                    <div class="columns medium-5 small-12 description">
                        <span class="description__text">
                            {{ entry.description }}
                        </span>
                    </div>
                </div>

                <div class="ending">
                    <div class="text">
                        <p>If you are interested in working together with me, don't hesitate to pop up in my inbox. I'll be happy to get in contact with you—</p>
                        <a href="mailto:felix.tesche@gmail.com" class="mail-button" target="_blank"> Send me a Mail →</a>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import HeadlineWithLabel from '@/components/typography/HeadlineWithLabel';

    export default {
        components: {
            HeadlineWithLabel
        },
         data() {
            return {
                vita: null
            }
        },
        created() {
            this.getVita()
        },
        methods: {
            getVita() {
                this.$prismic.client.getSingle('vita')
                    .then((document) => {
                        this.vita = document.data.entry
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        }
    }
</script>

<style lang="scss">
    @import '../assets/scss/base.scss';

    .vitae {
        section {
            background: $white-100;
        }

        &__row {
            height: auto;
            min-height: 5rem;
            border-top: 1px solid #E8E8E8;
            padding: 1rem;
        }

        &__row:last-child {
            border-bottom: 1px solid #E8E8E8;
        }

        .timespan {
            position: relative;
            padding: .5rem;
            display: flex;

            &__from {
                bottom: .5rem;
                left: .5rem;
                align-self: flex-end;
                color: $dark;
                &.isCentered {
                    align-self: center;
                    justify-self: center;
                }
            }

            &__slash {
                position: absolute;
                width: 3rem;
                height: 2px;
                left: 50%;
                top: 50%;
                transform: translateX(-50%) translateY(-50%) rotate(45deg);
                background: $dark;
            }

            &__to {
                position: absolute;
                top: .5rem;
                right: .5rem;
                color: $dark;
            }

            .ongoing {
                background: linear-gradient(to right, #212F35 4%, #212F35 5%, #FF6B8F 5%, #FF6B8F 15%,#212F35 15%);
                background-size: 200% auto;
                color: #000;
                background-clip: text;
                text-fill-color: transparent;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                animation: shine 2.5s linear infinite;
                @keyframes shine {
                    to {
                        background-position: -200% center;
                    }
                }
            }
        }

        .position {
            position: relative;
            padding: .5rem .5rem .5rem 1.5rem;
            display: flex;
            flex-direction: column;

            &__head {
                top: .5rem;
                font-weight: 600;
                color: $dark;
            }

            &__company {
                 bottom: .5rem;
                 color: $dark;
                 opacity: .75;
            }
        }

        .description {
            padding: 0 .5rem;
            opacity: .75;
            @include sm () {
                padding-bottom: 1rem;
            }

            &__text {
                position: relative;
                top: .5rem;
                color: $dark;
            }
        }
    }

    .ending {
        padding-top: 8rem;

        @include sm () {
            padding-top: 4rem;
        }  

        .text {
            display: flex;
            flex-direction: column;
            align-items: center;
            max-width: 45ch;
            margin: 0 auto;   
            position: relative;
            @include sm () {
                padding: 0 1.5rem;
            }
            
            .mail-button {
                @include touch-device () { 
                &:after {
                        content: '';
                        background-image: url("/assets/img/icon-mail.svg");
                        font-family: 'Inter';
                        font-size: 7px;
                        position: absolute;
                        top: .75rem;
                        right: -1rem;
                        background-size: cover;
                        display: block;
                        width: 24px;
                        height: 24px;
                        border-radius: 50%;
                        animation: pop $t3 $spring;
                        animation-fill-mode: forwards;
                        animation-iteration-count: 1;
                        opacity: 0;
                        filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.1));
                    }
                }
                z-index: 10;
                &:hover {
                    &:after {
                        content: '';
                        background-image: url("/assets/img/icon-mail.svg");
                        font-family: 'Inter';
                        font-size: 7px;
                        position: absolute;
                        top: .75rem;
                        right: -1rem;
                        background-size: cover;
                        display: block;
                        width: 24px;
                        height: 24px;
                        border-radius: 50%;
                        animation: pop $t3 $spring;
                        animation-fill-mode: forwards;
                        animation-iteration-count: 1;
                        opacity: 0;
                        filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.1));
                    }
                }
            }
        }

        @keyframes pop {
            from {
                opacity: 0;
                transform: scale(.6) rotate(7deg)
            }
            to {
                opacity: 1;
                transform: scale(1) rotate(0)
            }
        }

        a {
            margin-top: 2rem !important;
            position: relative;
        }
            
        p, a {
            margin: 0 auto;    
            color: $dark;
        }
    }
</style>